import { AccountCircle, Message, LocalPhone } from '@mui/icons-material';
import AppsTwoToneIcon from '@mui/icons-material/AppsTwoTone';
import DoneIcon from '@mui/icons-material/Done';
import FolderIcon from '@mui/icons-material/Folder';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import Logout from '@mui/icons-material/Logout';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import Settings from '@mui/icons-material/Settings';
import TaskIcon from '@mui/icons-material/Task';
import { Badge, Fade, IconButton, ListItemText, Tooltip } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { FC, useState } from 'react';
import { MdOutlineHelpOutline } from 'react-icons/md';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { IWorkspace } from 'wisestep-base';

import { useWorkspaceContext } from '../../context';
import AppsMenuModal from '../../features/apps/AppsMenuModal';
import { NotificationModal } from '../../features/FirebaseNotification';
import InviteUserModal from '../../features/users/components/InviteUserModal';
import InviteUserSuccessModal from '../../features/users/components/InviteUserSuccessModal';
import { UserAccessAction, useUserAccessAuthz } from '../../hooks/useUserAccessAuthz';
import { openUrlInNewTab } from '../../utils/openUrlInNewTab';
import { logout } from '../../utils/token';
import { useNotificationSSEStore } from '../NotificationSSE/utils/NotificationSSEStore';

const AccountMenu: FC<{ isAdmin?: boolean; workspacesList: IWorkspace[] }> = ({
  isAdmin = false,
  workspacesList = [],
}) => {
  const workspaceContext = useWorkspaceContext();
  const [openAppsMenu, setOpenAppsMenu] = useState<boolean>(false);
  const notificationCount = useNotificationSSEStore((state) => state.unReadCount);
  const [anchor1El, setAnchor1El] = useState<null | HTMLElement>(null);
  const [workspaceListOpen, setWorkspaceListOpen] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [purchaseEl, setPurchaseEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const open1 = Boolean(anchor1El);
  const openPurchaseMenu = Boolean(purchaseEl);
  const openWorkspaceList = Boolean(workspaceListOpen);

  const { access: userAccessControl } = useUserAccessAuthz([UserAccessAction.INVITE_USERS_ACCESS]);

  const inviteAccess = workspaceContext.owns || userAccessControl[0];

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClick1 = (event: React.MouseEvent<HTMLElement>) => {
    setAnchor1El(event.currentTarget);
  };

  const handleWorkspaceClick = (event: React.MouseEvent<HTMLElement>) => {
    setWorkspaceListOpen(event.currentTarget);
  };

  const switchWorkspace = (workspace: IWorkspace) => {
    if (workspace.id != workspaceContext.id) {
      const host = document.location.host;
      let newHost = '';
      if (host.indexOf('.') > -1) {
        newHost = '//' + workspace.link + host.substring(host.indexOf('.')) + '/';
      } else {
        newHost = '//' + workspace.link + '.' + host + '/';
      }
      localStorage.removeItem('FCMToken');
      window.open(document.location.protocol + newHost);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
    setAnchor1El(null);
    setWorkspaceListOpen(null);
  };

  const handleOpenAppsMenu = () => setOpenAppsMenu(true);

  const onClickFAQ = () => window.open('/help-and-knowledge/faq-payment-integration');
  const handleCloseAppsMenu = () => setOpenAppsMenu(false);

  const [openInviteUserDialog, setOpenInviteUserDialog] = useState<boolean>(false);
  const [openInviteSuccessModal, setOpenInviteSuccessModal] = useState<boolean>(false);

  return (
    <>
      {!isAdmin && (
        <>
          {inviteAccess && (
            <Tooltip title="Invite User to Workspace">
              <IconButton
                size="large"
                /*  color="inherit" */
                onClick={() => setOpenInviteUserDialog(true)}
              >
                <Badge badgeContent={0} color="error">
                  <PersonAddIcon />
                </Badge>
              </IconButton>
            </Tooltip>
          )}
          {openInviteUserDialog && (
            <InviteUserModal
              open={openInviteUserDialog}
              handleClose={() => setOpenInviteUserDialog(false)}
              onSuccess={() => setOpenInviteSuccessModal(true)}
            />
          )}
          {openInviteSuccessModal && (
            <InviteUserSuccessModal
              setOpenInviteSuccessModal={setOpenInviteSuccessModal}
              setOpenInviteUserDialog={setOpenInviteUserDialog}
            />
          )}
          <Tooltip title="SMS Logs">
            <IconButton size="large" component={RouterLink} to="/sms-logs">
              <Badge badgeContent={0} color="error">
                <Message />
              </Badge>
            </IconButton>
          </Tooltip>
          <Tooltip title="Call Logs">
            <IconButton size="large" component={RouterLink} to="/call-logs">
              <Badge badgeContent={0} color="error">
                <LocalPhone />
              </Badge>
            </IconButton>
          </Tooltip>
          <Tooltip title="Reminders">
            <IconButton size="large" onClick={() => navigate('tasks')}>
              <Badge badgeContent={0} color="error">
                <TaskIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          <Tooltip title="Notifications">
            <IconButton size="large" onClick={handleClick1}>
              <Badge badgeContent={notificationCount} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          <NotificationModal anchorEl={anchor1El} open={open1} onClose={handleClose} />
          <Tooltip title="Apps">
            <IconButton size="large" onClick={handleOpenAppsMenu}>
              <Badge badgeContent={0} color="error">
                <AppsTwoToneIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          <AppsMenuModal open={openAppsMenu} handleClose={handleCloseAppsMenu} />
          <Tooltip title="Help">
            <IconButton
              size="large"
              aria-label="show 4 new mails"
              onClick={() => openUrlInNewTab('https://wisestep.freshdesk.com/support/home')}
            >
              <Badge badgeContent={0} color="error">
                <HelpOutlineRoundedIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          {workspaceContext.owns && (
            <Tooltip title="Purchase">
              <IconButton
                onClick={(e) => setPurchaseEl(e.currentTarget)}
                size="small"
                sx={{ ml: 1.1 }}
                aria-controls={openPurchaseMenu ? 'purchase' : undefined}
                aria-haspopup="true"
                aria-expanded={openPurchaseMenu ? 'true' : undefined}
              >
                <Badge badgeContent={0} color="error">
                  <MonetizationOnOutlinedIcon />
                  <KeyboardArrowDownOutlinedIcon />
                </Badge>
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
      <Tooltip title="Workspaces">
        <IconButton
          onClick={handleWorkspaceClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={openWorkspaceList ? 'workspace-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={openWorkspaceList ? 'true' : undefined}
        >
          <FolderCopyIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Account settings">
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <AccountCircle />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        TransitionComponent={Fade}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {!isAdmin && (
          <MenuItem
            component={RouterLink}
            to={`/recruiter/profile?email=${workspaceContext?.userId}&isOverLap=yes&isUserAnalytics=true`}
          >
            <ListItemIcon>
              <PersonIcon fontSize="small" />
            </ListItemIcon>
            Profile
          </MenuItem>
        )}
        {!isAdmin && (
          <MenuItem component={RouterLink} to="/app-settings/teams-and-users">
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            Settings
          </MenuItem>
        )}
        <MenuItem onClick={async () => await logout()}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      <Menu
        anchorEl={workspaceListOpen}
        id="workspace-menu"
        open={openWorkspaceList}
        onClose={handleClose}
        onClick={handleClose}
        TransitionComponent={Fade}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {workspacesList.map((workspace, index) => (
          <MenuItem key={index} onClick={() => switchWorkspace(workspace)}>
            <ListItemIcon>
              <FolderIcon fontSize="small" />
            </ListItemIcon>
            {workspace.name}
            {workspace.id == workspaceContext.id ? <DoneIcon fontSize="small" /> : <></>}
          </MenuItem>
        ))}
      </Menu>
      <Menu
        anchorEl={purchaseEl}
        id="purchase"
        open={openPurchaseMenu}
        onClose={() => setPurchaseEl(null)}
        onClick={() => setPurchaseEl(null)}
        TransitionComponent={Fade}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem component={RouterLink} to="/app-settings/plan-details">
          <ListItemIcon>
            <ReceiptOutlinedIcon style={{ fontSize: '22px' }} />
          </ListItemIcon>
          My Plan
        </MenuItem>
        <MenuItem component={RouterLink} to="/app-settings/my-invoices">
          <ListItemIcon>
            <ReceiptLongIcon fontSize="small" />
          </ListItemIcon>
          Invoices
        </MenuItem>
        <MenuItem component={RouterLink} to={location.pathname}>
          <ListItemIcon onClick={() => onClickFAQ()}>
            <MdOutlineHelpOutline size={20} />
          </ListItemIcon>
          <ListItemText primary="FAQs" onClick={() => onClickFAQ()} />
        </MenuItem>
        <MenuItem component={RouterLink} to="/plan/purchase">
          <ListItemIcon>
            <LocalAtmIcon fontSize="small" />
          </ListItemIcon>
          Pricing
        </MenuItem>
      </Menu>
    </>
  );
};

export default AccountMenu;
